import Vue from "vue";
import App from "./App.vue";
import CKEditor from "@ckeditor/ckeditor5-vue";
// import VueSocketIO from "vue-socket.io";
import VueRouter from "vue-router";
import Vuex from "vuex";
import VueYoutube from "vue-youtube";
import { format } from "date-fns";
import VueHotkey from "v-hotkey";
import ImageKit from "imagekitio-vue";
import { BASE_PATH } from "./constants";

import titleMixin from "./mixins/titleMixin";

import { setGlobals } from "./config/axios";
import store from "./store/index";

import router from "./router";

import VueGtag from "vue-gtag";

import mixpanel from 'mixpanel-browser';

import { VueWindowSizePlugin } from "vue-window-size/option-api";

/** For virtualizing large lists */
import VueVirtualScroller from "vue-virtual-scroller";

import isMobile from 'ismobilejs';

setGlobals();
Vue.config.productionTip = false;
Vue.use(VueRouter);
Vue.use(Vuex);
Vue.use(CKEditor);
Vue.use(VueYoutube);
Vue.use(VueHotkey);
Vue.mixin(titleMixin);

Vue.use(VueWindowSizePlugin);

Vue.use(VueVirtualScroller);

Vue.use(ImageKit, {
  urlEndpoint: "https://ik.imagekit.io/elysiumone",
  publicKey: "public_lxZGS71ZHxIolHx1LTmIfukDqJU=",
  authenticationEndpoint: BASE_PATH + "/api/external/imagekit-signature",
});

Vue.use(VueGtag, {
  config: { id: "G-DNG9ZN3R0H" },
});

mixpanel.init('40a2bc5f3d7080ea42d04275d17d3b1f'); 
window.mixpanel = mixpanel;

Vue.prototype.$isMobile = isMobile().phone;

// let connection = process.env.NODE_ENV === "production" || process.env.NODE_ENV === "test" ? window.location.host : "http://localhost:3000";

// Vue.use(
//   new VueSocketIO({
//     connection,
//   })
// );

Vue.filter("formatDate", function (value) {
  if (!value) return "";
  return format(value, "MM/DD/YYYY hh:mm");
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
